import React, { useContext, useEffect, useState } from "react";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { storeQuestionPagination } from "redux/action/questionAction";
import { Card, Layout, Skeleton } from "antd";
import AIHintSliderMain from "./AIHintSliderMain";
import QuestionsHeader from "Pages/Questions/QuestionsHeader";
import shuffle from "lodash/shuffle";
import QuestionsTable from "Pages/Questions/QuestionsHomeScreen/QuestionsTable";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import { BASE_URL } from "utilFunctions/Constants/urlConstants";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { StyledMainDiv } from "Pages/MyBatchesAntd/MyBatchesAntd";
import TitleAntdComponent from "utilFunctions/shared/AntdSharedComponents/TitleAntdComponent";
const { Sider, Content } = Layout;
const siderStyle = {
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#fff",
  padding: "16px",
  margin: "8px 0px 8px 16px",
  borderRadius: "8px",
};
const AIHintHomePage = () => {
  const { screen } = useWindowSize();
  const ToastDispatch = useContext(ToastContextDispatch);
  const { questionFilter } = useSelector((state) => state.questionReducer);
  const userInfo = useContext(UserInfoContext);
  const dispatch = useDispatch();
  const location = useLocation();
  const [refresh, setRefresh] = useState(false);
  const [questionListLoader, setquestionListLoader] = useState(false);
  const [filterValues, setfilterValues] = useState(
    questionFilter &&
      questionFilter != null &&
      Object.keys(questionFilter).length
      ? questionFilter
      : { hintStatus: "HU" }
  );
  const [bucket, setBucket] = useState(userInfo != "" ? userInfo.bucket : "");
  const [questionsList, setQuestionsList] = useState([]);
  const [isSiderOpen, setIsSiderOpen] = useState(false);
  const [selectedQuesInSide, setSelectedQuesInSide] = useState(null);
  const [dataTotalCount, setDataTotalCount] = useState("");
  const [userVerifiedCount, setUserVerifiedCount] = useState("");
  const [state, setstate] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
    question: null,
    index: null,
    filter: false,
    NoResult: false,
    questionBulkUpload: false,
    questionBulkUpdate: false,
    questionBulkCSV: false,
  });
  const [pagination, setPagination] = useState({
    pageSize: 100,
    total: 30,
    pageSizeOptions: ["100"],
    showSizeChanger: true,
    current: 1,
    sortField: "updatedAt",
    sortOrder: "DESC",
  });
  const handleFetchQuestion = (urls) => {
    let newCountUrl = urls.split("?");
    if (newCountUrl !== undefined && newCountUrl.length > 1) {
      fetchQuestion(BASE_URL + "question/v2?" + newCountUrl[1]);
    } else {
      fetchQuestion(BASE_URL + "question/v2?" + urls);
    }
  };

  const fetchQuestion = async (url) => {
    setquestionListLoader(true);
    getAPIRequest({
      url,
      success: (response) => {
        setquestionListLoader(false);
        const data = response?.data;
        let shuffledArray = shuffle(data["data"] ?? []);
        setQuestionsList(shuffledArray ?? []);
        if (shuffledArray) {
          const el = shuffledArray[0];
          handleIdsClick(el);
        }
        let n = {
          total: data["totalCount"],
        };
        setPagination({ ...pagination, ...n });
        dispatch(storeQuestionPagination(n));
        setstate({
          ...state,
          NoResult: data["totalCount"] === 0 ? true : false,
        });
        //setQuestionsList(data['data'] || [])
        setDataTotalCount(data["totalCount"] || "");
      },
      failure: (error) => {
        setquestionListLoader(false);
        if (error?.response?.data?.message == "No record found!") {
          setQuestionsList([]);
          setIsSiderOpen(false);
          setSelectedQuesInSide(null);
          setDataTotalCount("");
          setPagination({
            pageSize: 100,
            total: 30,
            pageSizeOptions: ["100"],
            showSizeChanger: true,
            current: 1,
            sortField: "updatedAt",
            sortOrder: "DESC",
          });
        }
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message:
            error?.response?.data?.code == "NF"
              ? "No Record Found"
              : error?.response?.data?.message,
        });
      },
    });
  };

  const fetchUserverfiedCount = async (userID) => {
    let url = BASE_URL + `bulkHint/getQuestionVerifiedCount?userId=${userID}`;
    getAPIRequest({
      url,
      success: (response) => {
        const data = response?.data;
        if (data?.data) {
          setUserVerifiedCount(data?.data["verifiedCount"] ?? "");
        }
      },
      failure: () => {
        setUserVerifiedCount("");
      },
    });
  };
  useEffect(() => {
    console.log(userInfo, "userInfo");
    setBucket(userInfo.bucket);
    if (userInfo.id) {
      fetchUserverfiedCount(userInfo.id);
    }
  }, [userInfo]);
  useEffect(() => {
    const limit = pagination.pageSize;
    const offset = (pagination.current - 1) * limit;
    const sortBy = pagination.sortField;
    const sortDir = pagination.sortOrder;
    let filterId;
    if (location.state) {
      filterId = location.state.contentId;
    }
    if (location.search) {
      filterId = new URLSearchParams(location.search).get("id");
    }
    let bucketString =
      "1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,46,47,49,51,52,53,54,55,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77";
    if (filterId !== undefined) {
      const ret = [];
      const formValues =
        Object.keys(questionFilter).length > 0 ? questionFilter : filterValues;

      for (const key in formValues) {
        if (Object.prototype.hasOwnProperty.call(formValues, key)) {
          if (formValues[key] != null && formValues[key] !== "") {
            ret.push(
              encodeURIComponent(key) +
                "=" +
                encodeURIComponent(formValues[key])
            );
          }
        }
      }

      if (bucketString != "") {
        handleFetchQuestion(
          BASE_URL +
            `question/v2?sortBy=${sortBy}&sortDir=${sortDir}&limit=${limit}&questionId=${filterId}&buckets=${bucketString}`
        );
      }
    } else if (filterId === undefined && filterValues != undefined) {
      const ret = [];
      let Off_Set = isNaN(offset) ? 0 : offset;
      let formValues;
      let questionFilterArr = { ...questionFilter };
      delete questionFilterArr["selectedOptionsHintAnsSol"];
      delete questionFilterArr["usersListArr"];
      if (Object.keys(questionFilterArr).length > 0) {
        formValues = questionFilterArr;
      } else formValues = { ...filterValues };
      if (formValues?.hintStatus && formValues?.hintStatus != null) {
        formValues["tags"] = formValues?.hintStatus;
        delete formValues?.hintStatus;
      }
      let isbucketInFilter = formValues.buckets;
      for (var key in formValues) {
        if (Object.prototype.hasOwnProperty.call(formValues, key)) {
          if (formValues[key] != null && formValues[key] != "") {
            ret.push(
              encodeURIComponent(key) +
                "=" +
                encodeURIComponent(formValues[key])
            );
          }
        }
      }
      if (ret.length > 0) {
        if (
          bucketString != "" &&
          (isbucketInFilter === null ||
            isbucketInFilter == undefined ||
            isbucketInFilter == "")
        ) {
          handleFetchQuestion(
            BASE_URL +
              `question/v2?sortBy=${sortBy}&sortDir=${sortDir}&limit=${limit}&offset=${Off_Set}&buckets=${bucketString}&` +
              ret.join("&"),
            formValues
          );
        } else if (
          isbucketInFilter &&
          isbucketInFilter != null &&
          isbucketInFilter != ""
        ) {
          handleFetchQuestion(
            BASE_URL +
              `question/v2?sortBy=${sortBy}&sortDir=${sortDir}&limit=${limit}&offset=${Off_Set}&` +
              ret.join("&"),
            formValues
          );
        }
      } else {
        if (bucketString != "") {
          handleFetchQuestion(
            BASE_URL +
              `question/v2?sortBy=${sortBy}&sortDir=${sortDir}&limit=${limit}&offset=${Off_Set}&buckets=${bucketString}`
          );
        }
      }
    } else {
      if (bucketString != "") {
        handleFetchQuestion(
          BASE_URL +
            `question/v2?sortBy=${sortBy}&sortDir=${sortDir}&limit=${limit}&buckets=${bucketString}`
        );
      } else {
        handleFetchQuestion(
          BASE_URL +
            `question/v2?sortBy=${sortBy}&sortDir=${sortDir}&limit=${limit}`
        );
      }
    }
  }, [
    refresh,
    bucket,
    pagination.pageSize,
    pagination.current,
    pagination.sortField,
    pagination.sortOrder,
  ]);
  const handleIdsClick = (el) => {
    setIsSiderOpen(true);
    setSelectedQuesInSide(el);
  };
  const closeQuesContentSlider = () => {
    setIsSiderOpen(false);
    setSelectedQuesInSide(null);
  };
  return (
    <StyledMainDiv screen={screen}>
      {["xxl", "xl", "lg"].includes(screen) ? (
        <>
          <QuestionsHeader
            mode="AIHint"
            setRefresh={setRefresh}
            setfilterValues={setfilterValues}
            filterValues={filterValues}
            totalQuestionCount={dataTotalCount}
            userVerifiedCount={userVerifiedCount}
            fetchQuestion={handleFetchQuestion}
            sortBy={pagination.sortField}
            sortDir={pagination.sortOrder}
            limit={pagination.pageSize}
          ></QuestionsHeader>
          <Layout className="antdLayoutCss">
            <Content>
              {" "}
              {questionListLoader ? (
                <Card>
                  <br />
                  <Skeleton active paragraph={{ rows: 2 }}></Skeleton>
                  <br />
                  <Skeleton active paragraph={{ rows: 2 }}></Skeleton>
                  <br />
                  <Skeleton active paragraph={{ rows: 2 }}></Skeleton>
                  <br />
                  <Skeleton active paragraph={{ rows: 2 }}></Skeleton>
                  <br />
                  <Skeleton active paragraph={{ rows: 2 }}></Skeleton>
                </Card>
              ) : (
                <QuestionsTable
                  mode="AIHint"
                  selectedQuesInSide={selectedQuesInSide}
                  questionListLoader={questionListLoader}
                  data={questionsList}
                  tablecolumns={["questionId", "questionText", "hintStatus"]}
                  setData={setQuestionsList}
                  pagination={pagination}
                  setPagination={setPagination}
                  handleIdsClick={handleIdsClick}
                />
              )}
            </Content>
            {isSiderOpen && selectedQuesInSide != null ? (
              <Sider width="60%" style={siderStyle}>
                <AIHintSliderMain
                  mode="AIHint"
                  question={selectedQuesInSide}
                  closeQuesContentSlider={closeQuesContentSlider}
                  setRefresh={setRefresh}
                  userVerifiedCount={userVerifiedCount}
                  setUserVerifiedCount={setUserVerifiedCount}
                />
              </Sider>
            ) : null}
          </Layout>
        </>
      ) : (
        <div className="d-flex p-3 w-100 justify-content-center align-items-center">
          <TitleAntdComponent
            title={
              "Please use a laptop or tablet to verify AI-generated hints and solutions."
            }
          ></TitleAntdComponent>
        </div>
      )}
    </StyledMainDiv>
  );
};

export default AIHintHomePage;
